'use strict';

/**
 * Formats phone number to XXX-YYY-ZZZZ
 * @param {string} phone - User's phone number
 * @return {string} - formated phone number
 */
function formatPhoneNumber(phone) {
    if (!phone) {
        return phone;
    }

    // Remove all non-digits
    let digits = phone.replace(/\D/g, '');

    // Apply XXX-YYY-ZZZZ format
    if (digits.length > 6) {
        return digits.slice(0, 3) + '-' +
                digits.slice(3, 6) + '-' +
                digits.slice(6, 10);
    } else if (digits.length > 3) {
        return digits.slice(0, 3) + '-' +
                digits.slice(3);
    } else {
        return digits;
    }
}

/**
 * Format phone number on focus out
 * @returns {void}
 */
const handleFormatPhoneNumber = (e) => {
    e.preventDefault();

    const $phoneInput = $(e.target);
    const phoneValue = $phoneInput.val();

    $phoneInput.attr('maxlength', 12);
    if (!phoneValue || !phoneValue.length) {
        return;
    }

    let formattedPhone = formatPhoneNumber(phoneValue);
    if (formattedPhone) {
        $phoneInput.val(formattedPhone);
    }
}

/**
 * handle phone field focus in to remove dashes
 * @returns {void}
 */
const handlePhoneFieldFocusIn = (e) => {
    let cursor = this.selectionStart;
    const $phoneInput = $(e.target);
    const phoneValue = $phoneInput.val();

    let maxLen = phoneValue.indexOf('-') > -1 ? 12 : 10;

    $phoneInput.attr('maxlength', maxLen);
    if (!phoneValue || !phoneValue.length) {
        return;
    }

    let formattedPhone = formatPhoneNumber(phoneValue);
    $phoneInput.val(formattedPhone);
    this.setSelectionRange(cursor, cursor);
}

const formatPhone = (phoneSelector) => {
    $(phoneSelector).each(function() {
        var $phoneElement = $(this);

        if ($phoneElement.val()) {
            let formattedPhone = formatPhoneNumber($phoneElement.val());
            $phoneElement.val(formattedPhone);
        }

        $phoneElement.on('input, focusin', handlePhoneFieldFocusIn);
        $phoneElement.on('focusout', handleFormatPhoneNumber);
    });
}

module.exports = {
    formatPhone: formatPhone
};
